




















































































































































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import VCDateTimePicker from "@/components/form_components/VCDateTimePicker.vue";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import { storePasien } from "@/store/modules/pasien";
import { IdentitasPasien } from "@/types";
import { storeDokter } from "@/store/modules/dokter";
import RegisterKunjungan from "@/store/modules/RegisterKunjungan";
import { getAge, formatDMYDate } from "@/utility/DateUtils";
import SvcPersetujuanPlebotomi from "@/services/PersetujuanPlebotomi";
import StorePersetujuanPlebotomi from "@/store/modules/PersetujuanPlebotomi";
import { prefillRuangRawat } from "@/utils/prefillBangsalKelas";
import UnitRuangPicker from "@/components/common/UnitRuangPicker.vue";
import { localISODate, parseLocalDate } from "@/utils/localDate";
import { JENIS_KELAMIN_OPTIONS, normalisasiJk } from "@/utils/jenisKelamin";
import {
  CHECKLIST_PLEBOTOMI,
  HUBUNGAN_PERSETUJUAN_DARAH
} from "./persetujuanLayananDarah";
import moment from "moment";
import { opsiBagianPenyakit } from "./persetujuanLayananDarah";

@Component({
  components: { VCDateTimePicker, UnitRuangPicker },
  inject: { isReadOnly: { default: () => () => false } }
})
export default class PersetujuanPlebotomiInputCard extends Vue {
  get opsiBagian(): string[] {
    return opsiBagianPenyakit(this.bagian_penyakit);
  }

  @Prop() readonly register!: string;
  @Prop() dataSuket!: any;

  isReadOnly!: () => boolean;

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  valid = false;
  saving = false;

  requiredRule = [v => !!v || "*Kolom ini harus diisi"];
  hariIni = moment()
    .endOf("day")
    .toDate();

  jenisKelaminOptions = JENIS_KELAMIN_OPTIONS;
  golonganDarahOptions = ["A", "B", "O", "AB"];
  hubunganOptions = HUBUNGAN_PERSETUJUAN_DARAH;
  checklistItems = CHECKLIST_PLEBOTOMI;

  is_diri_sendiri: boolean = this.isiAwal.is_diri_sendiri ?? true;

  pembuat = this.pembuatAwal();

  golongan_darah = this.isiAwal.golongan_darah || "";
  diagnosis = this.isiAwal.diagnosis || "";
  bagian_penyakit = this.isiAwal.bagian_penyakit || "";
  ruang_rawat =
    this.isiAwal.ruang_rawat ||
    (this.dataSuket ? "" : prefillRuangRawat(RegisterKunjungan.register, this.register));

  checklist: Record<string, boolean> = CHECKLIST_PLEBOTOMI.reduce(
    (acc, item) => ({
      ...acc,
      [item.key]: !!(this.isiAwal.checklist || {})[item.key]
    }),
    {}
  );

  saksi_1 = this.isiAwal.saksi_1 || "";
  saksi_2 = this.isiAwal.saksi_2 || "";
  tanggal_persetujuan: Date | null = this.isiAwal.tanggal_persetujuan
    ? moment(this.isiAwal.tanggal_persetujuan).toDate()
    : new Date();
  signee_user_id = this.dataSuket?.signee_user_id || this.user.id;
  creator_user_id = this.dataSuket?.creator_user_id || this.user.id;
  surat_date: string =
    this.dataSuket?.surat_date || moment().format("YYYY-MM-DD");

  get isiAwal(): any {
    return (this.dataSuket && this.dataSuket.content) || {};
  }

  get suratDate(): Date | null {
    return parseLocalDate(this.surat_date);
  }

  set suratDate(val: Date | null) {
    this.surat_date = val ? localISODate(val) : "";
  }

  get pasien(): Partial<IdentitasPasien> {
    return storePasien.identitasPasien || {};
  }

  get user() {
    return userModule.user;
  }

  get listDokter() {
    return storeDokter.list;
  }

  pembuatAwal() {
    const isi = (this.dataSuket && this.dataSuket.content) || {};
    const simpan = isi.pembuat_pernyataan;

    if (simpan) {
      return {
        nama: simpan.nama || "",
        umur: simpan.umur || "",
        jenis_kelamin: normalisasiJk(simpan.jenis_kelamin) || "",
        nik: simpan.nik || "",
        alamat: simpan.alamat || "",
        telepon: simpan.telepon || "",
        hubungan: simpan.hubungan || "",
        hubungan_lain: simpan.hubungan_lain || ""
      };
    }

    return this.pembuatDariPasien();
  }

  pembuatDariPasien() {
    const pasien: any = storePasien.identitasPasien || {};

    return {
      nama: pasien.nama || "",
      umur: pasien.tgl_lahir ? getAge(formatDMYDate(pasien.tgl_lahir)) : "",
      jenis_kelamin: normalisasiJk(pasien.jk) || "",
      nik: pasien.nik || "",
      alamat: pasien.alamat || "",
      telepon: pasien.telp || "",
      hubungan: "diri_sendiri",
      hubungan_lain: ""
    };
  }

  get input() {
    return {
      register_id: this.dataSuket?.register_id || this.register,
      pasien_rm: this.dataSuket?.pasien_rm || this.pasien.rm,
      unit_id: this.dataSuket?.unit_id || this.user.unit_id,
      content: {
        is_diri_sendiri: this.is_diri_sendiri,
        pembuat_pernyataan: {
          ...this.pembuat,
          hubungan_lain:
            this.pembuat.hubungan === "lainnya" ? this.pembuat.hubungan_lain : ""
        },
        golongan_darah: this.golongan_darah || "",
        diagnosis: this.diagnosis,
        bagian_penyakit: this.bagian_penyakit,
        ruang_rawat: this.ruang_rawat,
        checklist: this.checklist,
        saksi_1: this.saksi_1,
        saksi_2: this.saksi_2,
        tanggal_persetujuan: this.tanggal_persetujuan
          ? moment(this.tanggal_persetujuan).format("YYYY-MM-DD HH:mm:ss")
          : null
      },
      surat_date: this.surat_date,
      signee_user_id: this.signee_user_id,
      creator_user_id: this.creator_user_id
    };
  }

  onDiriSendiriChange(val: boolean) {
    this.pembuat = val
      ? this.pembuatDariPasien()
      : {
          nama: "",
          umur: "",
          jenis_kelamin: "",
          nik: "",
          alamat: "",
          telepon: "",
          hubungan: "",
          hubungan_lain: ""
        };
  }

  save() {
    if (this.readOnly || this.saving) return;

    this.saving = true;

    const action = this.dataSuket
      ? SvcPersetujuanPlebotomi.update(this.dataSuket.id, this.input)
      : SvcPersetujuanPlebotomi.create(this.input);

    action
      .then(() => {
        appModule.NoticeDelay("Berhasil Simpan Persetujuan Plebotomi");
        this.close();
        StorePersetujuanPlebotomi.getSuketByRegister(this.register);
      })
      .finally(() => {
        this.saving = false;
      });
  }

  close() {
    this.$emit("close");
  }
}
